import React, { useEffect, useRef } from 'react'
import preview from '../../assets/clinicPreview.png'
import { useLocation } from 'react-router-dom';

export const Hero2 = () => {
    const product = useRef('');
    const { hash } = useLocation();
    useEffect(() => {
        if (product.current && hash.includes('#product')) {
            product.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [hash]);
    return (
        <div id='Hero2' className='min-h-[100vh] py-16 bg-[#100c1219] w-full px-[5vw] flex flex-col' ref={product}>
            {/* // This is the title */}
            <h1 className='text-4xl font-semibold text-blue-500'>Clinqo, built for everyone</h1>

            {/* // This is the buttons */}
            <div className="buttons flex flex-wrap w-full justify-around mt-10 gap-2">
                <button className='bg-blue-500 text-2xl w-72 px-11 py-4 text-white font-semibold rounded-lg mt-5'>
                    Clinics
                </button>
                <button className='bg-blue-500 text-2xl w-72 px-11 py-4 text-white font-semibold rounded-lg mt-5'>
                    Doctors
                </button>
                <button className='bg-blue-500 text-2xl w-72 px-11 py-4 text-white font-semibold rounded-lg mt-5'>
                    Pharmacies
                </button>
                <button className='bg-blue-500 text-2xl w-72 px-11 py-4 text-white font-semibold rounded-lg mt-5'>
                    Insurance TPA's
                </button>
            </div>

            <div className="flex flex-wrap justify-between w-full mt-5 flex-auto items-center">

                {/* // This is the description */}
                <div className='w-[45%] max-lg:w-[90%] flex flex-col gap-5 leading-5'>
                    <h1 className='text-2xl font-semibold'>Clinqo - For Clinics</h1>
                    <p>
                        Clinqo revolutionizes healthcare management by unleashing the Power of <span className='text-blue-500'> Data</span>, streamlining processes for efficient patient care. This strategic design prioritizes <span className='text-blue-500'> simplicity</span> and <span className='text-blue-500'> productivity </span>, making Clinqo an invaluable tool in healthcare administration.
                    </p>
                    <p>
                        <span className='text-blue-500'> Adaptability </span> is key, with Clinqo seamlessly scaling from small clinics to large hospitals, evolving alongside changing facility requirements. Its <span className='text-blue-500'> versatile </span> approach ensures the software is a tailored solution that grows with the unique needs of diverse healthcare settings.
                    </p>
                    <p>
                        Additionally, Clinqo emphasizes <span className='text-blue-500'> seamless integration </span> into existing workflows through network of <span className='text-blue-500'> SDK’s </span> and API’s. Beyond technological compatibility, the software aligns with daily healthcare dynamics, facilitating a smooth transition to a more efficient management system. This commitment enhances user acceptance, making Clinqo an <span className='text-blue-500'> pultimate choice </span> for healthcare professionals.
                    </p>

                </div>

                {/* // This is the image */}
                <img src={preview} alt="Clinic Preview " className=' w-[45%] max-lg:w-[90%] ' />
            </div>
        </div>

    )
}
